import React from 'react';
import { Platform } from 'react-native';
import { Drawer } from 'react-native-drawer-layout';
import { useSegments } from 'expo-router';
import { useDrawer } from '../contexts/DrawerContext';
import { useTheme } from '../contexts/ThemeContext';
import LeftSidebar from './LeftSidebar';

interface MobileDrawerProps {
  children: React.ReactNode;
}

export default function MobileDrawer({ children }: MobileDrawerProps) {
  const { isOpen, closeDrawer } = useDrawer();
  const { colors } = useTheme();
  const segments = useSegments();

  // On web, don't use the drawer - just render children
  if (Platform.OS === 'web') {
    return <>{children}</>;
  }

  // Disable drawer on post details to avoid conflict with iOS back gesture
  const isPostDetails = segments.includes('post') && segments.length > 1;
  const drawerEnabled = !isPostDetails;

  // If drawer is disabled but open, close it
  React.useEffect(() => {
    if (!drawerEnabled && isOpen) {
      closeDrawer();
    }
  }, [drawerEnabled, isOpen, closeDrawer]);

  if (!drawerEnabled) {
    return <>{children}</>;
  }

  return (
    <Drawer
      open={isOpen}
      onOpen={() => {}}
      onClose={closeDrawer}
      drawerType="slide"
      drawerPosition="left"
      drawerStyle={{ backgroundColor: colors.background }}
      renderDrawerContent={() => <LeftSidebar onClose={closeDrawer} />}
    >
      {children}
    </Drawer>
  );
}
